import React from 'react';
import {
    Container,
    Grid,
    Typography,
    Paper,
    List,
    ListItem,
    ListItemText,
    ThemeProvider,
    createTheme,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Switch,
    FormControlLabel,
} from '@mui/material';
import { useAuth } from '../../Auth/AuthProvider';
import { useNavigate, useParams } from 'react-router-dom';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { PlanShowAPI } from '../../Conections/RolesAndPermissionsConection';
import ErrorCard from '../../Conections/ErrorCard';
import { can } from '../../Conections/LogConections';

// Creamos un tema personalizado
const theme = createTheme();

export default function ShowPlan() {

    const auth = useAuth();
    const goTo = useNavigate();
    const idCompany = useParams();

    const [expanded, setExpanded] = React.useState(false);
    const [permission, setPermission] = React.useState(false);
    const [name, setName] = React.useState('');
    const [duration, setDuration] = React.useState('');
    const [price, setPrice] = React.useState('');
    const [privatev, setPrivate] = React.useState(false);
    const [permitido, setPermitido] = React.useState(false);


    React.useEffect(() => {
        reloaduser();
    }, []);

    async function reloaduser() {
        if (auth.getToken()) {
            const permisionShowCan = await can(auth.getToken(), auth.getCompany(), "/dashboard/rpp/showplan/:id");
            if (permisionShowCan) {
                const plan = await PlanShowAPI(auth.getToken(), auth.getCompany(), idCompany.id);
                if (typeof plan[0] === "number") {
                    setPermitido(false);
                } else {
                    setName(plan.name);
                    setDuration(plan.duration);
                    setPrice(plan.price);
                    setPrivate(plan.private === 1);
                    var result = Object.keys(plan.section).map((key) => [key, plan.section[key]]);
                    setPermission(result);
                    setPermitido(true);
                }
            }
            else {
                goTo("/dashboard");
            }
        }
        else {
            goTo(`/login`);
        }
    }

    const handleChangeA = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        permitido ? (
            <ThemeProvider theme={theme}>
                <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                    <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ mb: 4 }}>
                        Plan Information
                    </Typography>

                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <Paper elevation={3} sx={{ p: 3 }}>
                                <Typography variant="h5" component="h2" gutterBottom>
                                    Plan Data
                                </Typography>
                                <List>
                                    <ListItem>
                                        <ListItemText primary="Name" secondary={name} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Duration" secondary={duration} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Price" secondary={price} />
                                    </ListItem>
                                    <ListItem>
                                        <FormControlLabel control={<Switch checked={privatev} />} label="private" />
                                    </ListItem>
                                </List>
                            </Paper>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Paper elevation={3} sx={{ p: 3 }}>
                                <Typography variant="h5" component="h2" gutterBottom>
                                    Permission Data
                                </Typography>
                                {permission ?
                                    (
                                        permission.map((section, index) => (
                                            <Accordion expanded={expanded === index} onChange={handleChangeA(index)} key={index}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1bh-content"
                                                    id="panel1bh-header"
                                                >
                                                    <Typography sx={{ width: '33%', flexShrink: 0 }}>
                                                        {section[1].name}
                                                    </Typography>
                                                    <Typography sx={{ color: 'text.secondary' }}>
                                                        {section[1].section}
                                                    </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <List>
                                                        {
                                                            Object.keys(section[1].per).map((key) => [key, section[1].per[key]])
                                                                .map((permission, index) => (
                                                                    <ListItem key={index}>
                                                                        <Typography>
                                                                            {permission[1].name}
                                                                        </Typography>
                                                                    </ListItem>
                                                                ))

                                                        }

                                                    </List>
                                                </AccordionDetails>
                                            </Accordion>

                                        ))
                                    ) : (
                                        <List>
                                            <ListItem>
                                                <Typography variant="h7" component="h2" gutterBottom>
                                                    Empty
                                                </Typography>
                                            </ListItem>
                                        </List>
                                    )
                                }
                            </Paper>
                        </Grid>
                    </Grid >
                </Container >
            </ThemeProvider >
        ) : (
            <ErrorCard />
        )
    );
}